import { Link } from "react-router-dom";
import styles from "../styles/quienesSomos.module.css";

function Bloque01({
  imagen,
  titulo1,
  titulo2,
  descripcion,
  lista,
  ctaTexto = "GRATIS\n1ERA VISITA"
}) {
  return (
    <section className={styles.bloque01}>
      <div className={styles.imagenContainerBloque01}>
        <img src={imagen} alt="Imagen sección" className={styles.imagenBloque01} />
      </div>

      <div className={styles.textoContainerBloque01}>
        <div className={styles.containertituloBloque01}>
          <div className={styles.lineaYtexto}>
            <span className={styles.lineaBloque01}></span>
            <div className={styles.textoTitulo}>
              <span className={styles.tituloLinea}>{titulo1}</span>
              <span className={styles.tituloLinea}>{titulo2}</span>
            </div>
          </div>
        </div>

        <p className={styles.descripcionBloque01}>
          {descripcion}
        </p>

        <div className={styles.listayCTABloque01}>
          <ul className={styles.listaBloque01}>
            {lista.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <div className={styles.CTABloque01}>
            <Link to='/contacto' className={styles.CTAgratis}>
              {ctaTexto.split("\n").map((line, i) => (
                <div key={i}>{line}</div>
              ))}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Bloque01;

